import styled from 'styled-components';
import styles from '../../../styles';

const LoaderCover = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${styles.color.STONE};
  transform-origin: 100% 50%;
  transform: scale(1, 1);

  &.exited {
    display: none;
  }

  &.fade-exit {
    transform: scale(1, 1);
  }

  &.fade-exit.fade-exit-active {
    transform: scale(0, 1);
    transition: transform 0.5s ${styles.easing.inOutCubic};
    transition-delay: 0.1s;
  }
`;

export default LoaderCover;



// WEBPACK FOOTER //
// ./src/modules/pages/components/LoaderCover.js